import firebase from 'firebase';
import app from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyBoo2TnCZUetKt72lescKdFn-gM8wEiqHM',
  authDomain: 'usc-cabinet-mo.firebaseapp.com',
  databaseURL: 'https://usc-cabinet-mo-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'usc-cabinet-mo',
  storageBucket: 'usc-cabinet-mo.appspot.com',
  messagingSenderId: '756358513617',
  appId: '1:756358513617:web:944f0fcb075f00d43616f0',
  measurementId: 'G-V2BJLKXPW5',
};

export const vapidKey = 'BEBYoL46AINU7Uzma-E7YdFNANsOTUx8WBogxbRUgup5wuizNSpxrbu6JnvYeAvQ-FWRKzcPtwIoDkMBr_KGFNY';

app.initializeApp(firebaseConfig);
export const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null;
